export default "__VITE_ASSET__Bx$31txD__"